import { platform } from '../platform/bridge.js';
import { useUiStore } from '../store/ui.js';

/**
 * 새 버전 안내.
 *
 * 위장 중에는 절대 나타나지 않는다. 스프레드시트 화면 위에 "새 버전이
 * 준비되었습니다"가 뜨면 위장한 의미가 없다. 설치를 미뤄도 앱을 종료할
 * 때 자동으로 적용되므로 재촉하지 않는다.
 */
export function UpdateBanner() {
  const stealth = useUiStore((s) => s.view === 'stealth');
  const updateReady = useUiStore((s) => s.updateReady);

  if (stealth || updateReady === null) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-emerald-900 bg-emerald-950/60 px-3 py-1.5 text-xs text-emerald-200">
      <span>새 버전 {updateReady} 준비됨</span>
      <button
        type="button"
        onClick={() => platform.installUpdate()}
        className="rounded bg-emerald-700 px-2 py-0.5 font-medium text-white hover:bg-emerald-600"
      >
        재시작하고 적용
      </button>
      <span className="text-emerald-500/80">종료할 때 자동으로 적용됩니다</span>
    </div>
  );
}
